import { FETCH_IMPRESSION_STATS, LOAD_IMPRESSION_STATS } from '../Actions/ImpressionStats'

const initialState = {
  loading: false,
  data: {}
}

/**
 * ImpressionStatsReducer
 * @desc Reducer for handling impression stats state
 * @param {Object} state current state
 * @param {Object} action dispatched action
 * @return {Object} updated state
 */
export default function ImpressionStatsReducer (state = initialState, action) {
  switch (action.type) {
    case FETCH_IMPRESSION_STATS:
      return { ...state, loading: true }
    case LOAD_IMPRESSION_STATS:
      return { ...state, loading: false, data: action.data }
    default:
      return state
  }
}
